import { useSearchFilterStore } from '@/entities/map'
import {
  DiscountBadge,
  Overview,
  PriceDetail,
  RoomThumbnail,
  SuperHostBadge,
  type TRoomPreview,
} from '@/entities/room'
import { LikeButton } from '@/features/toggle-favorite-room'
import { Link } from '@/shared/i18n'
import { cn, getURLWithParams } from '@/shared/lib'

export const RoomItem = ({
  rid,
  roomName,
  province,
  town,
  propertyType,
  usingFee,
  mgmtFee,
  roomCnt,
  bathroomCnt,
  cookroomCnt,
  sittingroomCnt,
  picMain,
  isSuperHost,
  like,
  longtermDiscountPer,
  earlyDiscountAmount,
}: TRoomPreview) => {
  const startDate = useSearchFilterStore(state => state.filters.startDate)
  const endDate = useSearchFilterStore(state => state.filters.endDate)

  const hasDiscount = longtermDiscountPer > 0 || earlyDiscountAmount > 0

  return (
    <Link
      href={getURLWithParams(`/guest/room/${rid}`, {
        startDate,
        endDate,
      })}
      className="space-y-3"
      target="_blank"
    >
      <div className="relative overflow-hidden rounded-sm">
        {isSuperHost && (
          <SuperHostBadge className="absolute top-1.5 left-1.5 z-1" />
        )}
        <LikeButton
          roomId={rid}
          like={like}
          className="absolute top-0 right-0 z-1"
        />
        <DiscountBadge
          percent={longtermDiscountPer}
          amount={earlyDiscountAmount}
          className="absolute bottom-0 left-0 z-1 w-full rounded-t-none rounded-b-sm bg-transparent backdrop-blur-[50px]"
        />
        <RoomThumbnail
          src={picMain}
          alt={roomName}
          rounded
          size={224}
          ratio="3:2"
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8VA8AAkkBY8DEq9wAAAAASUVORK5CYII="
          className={cn(
            hasDiscount &&
              'after:absolute after:bottom-0 after:left-0 after:h-8 after:w-full after:rounded-b-[3px] after:bg-white/70 after:content-[""]',
          )}
        />
      </div>
      <div className="grow">
        <Overview
          size="large"
          province={province}
          town={town}
          propertyType={propertyType}
          roomName={roomName}
          roomCnt={roomCnt}
          bathroomCnt={bathroomCnt}
          cookroomCnt={cookroomCnt}
          sittingroomCnt={sittingroomCnt}
          usingFee={usingFee}
          mgmtFee={mgmtFee}
        />
        <PriceDetail usingFee={usingFee} mgmtFee={mgmtFee} />
      </div>
    </Link>
  )
}
